package com.evoapps.evoshift.ui.user

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.domain.util.AppClock
import com.evoapps.evoshift.widgets.rememberStableText
import com.evoapps.evoshift.widgets.ContextMenuArea
import com.evoapps.evoshift.widgets.ContextMenuItem
import androidx.compose.material.icons.filled.Event
import evoshift.composeapp.generated.resources.context_open_employee
import evoshift.composeapp.generated.resources.context_show_next_shift
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import evoshift.composeapp.generated.resources.nav_team
import evoshift.composeapp.generated.resources.leave_balances_open
import evoshift.composeapp.generated.resources.hiring_open
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.widgets.LocalContextSwitcher
import com.evoapps.evoshift.ui.notifications.NotificationsBell
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarHost
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.AdaptiveCardGrid
import com.evoapps.evoshift.ui.adaptive.ListDetailLayout
import com.evoapps.evoshift.ui.adaptive.PanePlaceholder
import com.evoapps.evoshift.ui.adaptive.showsDetailPane
import androidx.compose.foundation.border
import androidx.compose.runtime.saveable.rememberSaveable
import evoshift.composeapp.generated.resources.wide_pick_employee
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.hoverLift
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.BeachAccess
import androidx.compose.material.icons.filled.PersonSearch
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.Group
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.filled.UploadFile
import androidx.compose.ui.platform.testTag
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.plus
import kotlinx.datetime.todayIn
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.domain.usecase.team.TeamMemberStatus
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.TeamEvent
import com.evoapps.evoshift.viewmodels.TeamManagementViewModel
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.roster_picker_guest_from
import evoshift.composeapp.generated.resources.team_guests_hint
import evoshift.composeapp.generated.resources.team_guests_title
import androidx.compose.foundation.lazy.grid.GridItemSpan
import evoshift.composeapp.generated.resources.add
import evoshift.composeapp.generated.resources.bulk_undo
import evoshift.composeapp.generated.resources.dashboard_notifications
import evoshift.composeapp.generated.resources.dashboard_profile
import evoshift.composeapp.generated.resources.dashboard_select_workplace
import evoshift.composeapp.generated.resources.dashboard_workplace_switch
import evoshift.composeapp.generated.resources.search
import evoshift.composeapp.generated.resources.skeleton_no_role
import evoshift.composeapp.generated.resources.team_at_work_since
import evoshift.composeapp.generated.resources.ok
import evoshift.composeapp.generated.resources.team_group_manager
import evoshift.composeapp.generated.resources.team_group_manager_info
import evoshift.composeapp.generated.resources.team_group_manager_open_groups
import evoshift.composeapp.generated.resources.team_group_manager_title
import evoshift.composeapp.generated.resources.workplace_groups_default_name
import com.evoapps.evoshift.domain.model.UserPermission
import evoshift.composeapp.generated.resources.team_inactive
import evoshift.composeapp.generated.resources.team_next_shift
import evoshift.composeapp.generated.resources.dashboard_today
import evoshift.composeapp.generated.resources.dashboard_tomorrow
import evoshift.composeapp.generated.resources.team_no_employees
import evoshift.composeapp.generated.resources.staff_import_title
import evoshift.composeapp.generated.resources.team_no_scheduled_shifts
import org.jetbrains.compose.resources.stringResource

/** Test tags of the Team screen. */
object TeamTags {
    /** SH-214: "Import from a spreadsheet" in the empty team. */
    const val IMPORT = "team_import"
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TeamManagementScreen(
    viewModel: TeamManagementViewModel,
    onCreateNewWorkplaceClicked: () -> Unit,
    onRosterSelected: (Roster) -> Unit,
    onNavigateToSettings: (String) -> Unit,
    onNavigateToProfile: () -> Unit,
    onNavigateToEmployeeForm: (String, String?) -> Unit,
    onNavigateToWorkplaceSettings: (String) -> Unit,
    /** SH-98: a day of a month in the roster builder (the right-click menu's "next shift"). */
    onOpenShiftDay: ((rosterId: String, date: String) -> Unit)? = null,
    /** SH-113: the team's annual leave balances; null: not offered. */
    onOpenLeaveBalances: (() -> Unit)? = null,
    /** SH-125: the job posts and applicants; null: not offered. */
    onOpenHiring: (() -> Unit)? = null,
    /** SH-214: "Import from a spreadsheet" for the workplace; null: not offered. */
    onOpenImport: ((workplaceId: String) -> Unit)? = null,
    /**
     * SH-105: the person's form inside the detail pane on wide windows (a new person when the id
     * is null); null: the form is always its own screen ([onNavigateToEmployeeForm]).
     */
    employeeDetail: (@Composable (workplaceId: String, employeeId: String?, onClose: () -> Unit) -> Unit)? = null,
    /** SH-269: selecting people and "Edit selected"; null: not offered. */
    bulkEdit: com.evoapps.evoshift.viewmodels.BulkEmployeeEditViewModel? = null,
    /** SH-268: the owner's workplace groups (where a group manager is changed); null: not offered. */
    onOpenWorkplaceGroups: (() -> Unit)? = null,
) {
    // SH-268: a group manager tapped: who they are and where that is changed (not their form).
    var groupManagerShown by remember { mutableStateOf<com.evoapps.evoshift.domain.model.User?>(null) }
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    // SH-269: the selection (for those who manage the team, not once the plan ended).
    val bulkState = bulkEdit?.uiState?.collectAsStateWithLifecycle()?.value?.takeIf { state.capabilities.shows(Gate.TEAM_EDITING) }
    val onBulk: (com.evoapps.evoshift.viewmodels.BulkEvent) -> Unit = { bulkEdit?.onEvent(it) }
    // Each time the screen is shown again (back from the employee form), the list is re-read.
    LaunchedEffect(Unit) { viewModel.onEvent(TeamEvent.ScreenShown) }

    val contextSwitcher = LocalContextSwitcher.current
    var searchQuery by remember { mutableStateOf("") }
    // SH-105: on wide windows the person (or a new one) opens beside the list, not as a screen.
    val inPane = employeeDetail != null && LocalWindowWidthClass.current.showsDetailPane
    var paneEmployeeId by rememberSaveable { mutableStateOf<String?>(null) }
    var paneNewEmployee by rememberSaveable { mutableStateOf(false) }
    val closePane = {
        paneEmployeeId = null
        paneNewEmployee = false
        // Back from the form: the list is read again, as when the screen shows again.
        viewModel.onEvent(TeamEvent.ScreenShown)
    }
    val openEmployee: (workplaceId: String, employeeId: String?) -> Unit = { workplaceId, employeeId ->
        if (inPane) {
            paneEmployeeId = employeeId
            paneNewEmployee = employeeId == null
        } else {
            onNavigateToEmployeeForm(workplaceId, employeeId)
        }
    }
    val memberMenuLabels = TeamMemberMenuLabels(
        open = stringResource(Res.string.context_open_employee),
        showNextShift = stringResource(Res.string.context_show_next_shift)
    )

    val snackbarHostState = remember { SnackbarHostState() }
    val errorText = (state.error ?: state.inviteError)?.asString()
    LaunchedEffect(errorText) {
        errorText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(TeamEvent.ResetStatus)
        }
    }
    // SH-269: what a bulk change did, with Undo; the list shows the new positions at once.
    val bulkMessage = (bulkState?.error ?: bulkState?.message)?.asString()
    val undoLabel = stringResource(Res.string.bulk_undo)
    LaunchedEffect(bulkMessage) {
        val text = bulkMessage ?: return@LaunchedEffect
        viewModel.onEvent(TeamEvent.ScreenShown)
        val canUndo = bulkState?.undo != null
        // Cleared once shown (clearing first would end this effect, and the snackbar with it).
        val result = snackbarHostState.showSnackbar(text, actionLabel = undoLabel.takeIf { canUndo }, duration = androidx.compose.material3.SnackbarDuration.Long)
        onBulk(com.evoapps.evoshift.viewmodels.BulkEvent.MessageShown)
        if (result == androidx.compose.material3.SnackbarResult.ActionPerformed) onBulk(com.evoapps.evoshift.viewmodels.BulkEvent.Undo)
    }


    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.nav_team),
                showWorkplace = true,
                actions = listOfNotNull(
                    onOpenLeaveBalances?.takeIf { state.capabilities.shows(Gate.LEAVE_BALANCES) }?.let {
                        TopBarAction(stringResource(Res.string.leave_balances_open), Icons.Default.BeachAccess, it)
                    },
                    onOpenHiring?.takeIf { state.capabilities.shows(Gate.HIRING) }?.let {
                        TopBarAction(stringResource(Res.string.hiring_open), Icons.Default.PersonSearch, it)
                    },
                    // SH-214: adding many people at once, as adding one (MANAGE_TEAM, not on an ended plan).
                    onOpenImport?.takeIf { state.capabilities.shows(Gate.TEAM_EDITING) }?.let { open ->
                        state.currentWorkplaceId?.let { workplaceId ->
                            TopBarAction(stringResource(Res.string.staff_import_title), Icons.Default.UploadFile, { open(workplaceId) })
                        }
                    },
                    helpAction(HelpPage.TEAM),
                    notificationsAction(),
                    TopBarAction(stringResource(Res.string.dashboard_profile), Icons.Default.Person, onNavigateToProfile, collapsible = false)
                )
            )
        },
        floatingActionButton = {
            // Adding people is the managers' (MANAGE_TEAM), not once the plan ended (SH-65).
            // Not over a form open beside the list (SH-105): its own buttons are there.
            if (state.capabilities.shows(Gate.TEAM_EDITING) && !(inPane && (paneEmployeeId != null || paneNewEmployee))) Box(
                modifier = Modifier
                    .size(64.dp)
                    .clip(CircleShape)
                    .background(GoldMetallicBrush)
                    .handCursor()
                    .clickable {
                        state.currentWorkplaceId?.let { workplaceId ->
                            openEmployee(workplaceId, null)
                        }
                    },
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    imageVector = Icons.Default.Add,
                    contentDescription = stringResource(Res.string.add),
                    modifier = Modifier.size(32.dp),
                    tint = DeepNavy
                )
            }
        }
    ) { padding ->
        val maxWidth = LocalWindowWidthClass.current.wideContentMaxWidth
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
        ) {
            val workplaceId = state.currentWorkplaceId
            ListDetailLayout(
                selected = inPane && workplaceId != null && (paneEmployeeId != null || paneNewEmployee),
                onClose = closePane,
                maxWidth = maxWidth,
                placeholder = { PanePlaceholder(stringResource(Res.string.wide_pick_employee), Icons.Default.Group) },
                detail = {
                    if (workplaceId != null && employeeDetail != null) {
                        employeeDetail(workplaceId, paneEmployeeId.takeUnless { paneNewEmployee }, closePane)
                    }
                },
                list = {
            Column(
                modifier = Modifier
                    .fillMaxSize()
            ) {
                // SH-213: an outlined search field (a visible edge, the accent while focused).
                com.evoapps.evoshift.widgets.EvoSearchField(
                    value = searchQuery,
                    onValueChange = { searchQuery = it },
                    placeholder = stringResource(Res.string.search),
                    modifier = Modifier
                        .fillMaxWidth()
                        .contentWidth(maxWidth)
                        .padding(horizontal = 16.dp, vertical = 8.dp)
                )

                // SH-269: the selection bar ("Select", the count, the group, "Edit selected").
                val teamKeys = remember(state.employees, searchQuery, workplaceId) {
                    state.employees
                        .filter { searchQuery.isBlank() || it.user.displayName.contains(searchQuery, ignoreCase = true) }
                        .mapNotNull { status -> workplaceId?.let { com.evoapps.evoshift.viewmodels.MemberKey(it, status.user.uid) } }
                }
                val groupWide = bulkState?.selecting == true && bulkState.scope == com.evoapps.evoshift.viewmodels.BulkScope.GROUP
                if (bulkState != null && state.employees.isNotEmpty()) {
                    BulkSelectionBar(
                        state = bulkState,
                        visible = if (groupWide) bulkState.groupMembers.map { it.key } else teamKeys,
                        onEvent = onBulk,
                        modifier = Modifier.contentWidth(maxWidth).padding(horizontal = 16.dp)
                    )
                }

                Spacer(modifier = Modifier.height(8.dp))

                val loadError = state.loadError
                if (groupWide && bulkState != null) {
                    BulkGroupList(bulkState, onBulk, Modifier.fillMaxSize().contentWidth(maxWidth).padding(horizontal = 16.dp))
                } else if (state.employees.isEmpty() && loadError != null) {
                    // SH-168: the team could not be read: not "no employees", Try again.
                    com.evoapps.evoshift.widgets.ErrorState(loadError, onRetry = { viewModel.onEvent(TeamEvent.Retry) })
                } else if (state.employees.isEmpty() && state.isLoading) {
                    // SH-247: the team is on its way: its people's cards' shapes, not "no employees".
                    AdaptiveCardGrid(
                        contentPadding = PaddingValues(start = 16.dp, end = 16.dp, bottom = 80.dp),
                        maxWidth = maxWidth
                    ) {
                        items(TEAM_PLACEHOLDERS, key = { "placeholder-$it" }) {
                            Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                                com.evoapps.evoshift.widgets.SkeletonArea { com.evoapps.evoshift.widgets.SkeletonRowCard() }
                            }
                        }
                    }
                } else if (state.employees.isEmpty()) {
                    Column(
                        modifier = Modifier.fillMaxSize(),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center
                    ) {
                        Icon(
                            imageVector = Icons.Default.Group,
                            contentDescription = null,
                            modifier = Modifier.size(64.dp),
                            tint = DarkGold
                        )
                        Spacer(modifier = Modifier.height(16.dp))
                        Text(
                            stringResource(Res.string.team_no_employees),
                            style = MaterialTheme.typography.titleMedium,
                            color = DeepNavy
                        )
                        // SH-214: a new owner's team usually is in a spreadsheet already.
                        val workplaceId = state.currentWorkplaceId
                        if (onOpenImport != null && workplaceId != null && state.capabilities.shows(Gate.TEAM_EDITING)) {
                            Spacer(modifier = Modifier.height(16.dp))
                            androidx.compose.material3.OutlinedButton(
                                onClick = { onOpenImport(workplaceId) },
                                modifier = Modifier.testTag(TeamTags.IMPORT)
                            ) {
                                Icon(Icons.Default.UploadFile, contentDescription = null, tint = DeepNavy, modifier = Modifier.size(18.dp))
                                Text(stringResource(Res.string.staff_import_title), color = DeepNavy, modifier = Modifier.padding(start = 8.dp))
                            }
                        }
                    }
                } else {
                    // SH-158: filtered once per change of the team or the search, not on every recomposition.
                    val filteredEmployees = remember(state.employees, searchQuery) {
                        if (searchQuery.isBlank()) {
                            state.employees
                        } else {
                            state.employees.filter { it.user.displayName.contains(searchQuery, ignoreCase = true) }
                        }
                    }
                    // One column on phones; two or three columns of people on tablets and desktops.
                    AdaptiveCardGrid(
                        contentPadding = PaddingValues(start = 16.dp, end = 16.dp, bottom = 80.dp),
                        maxWidth = maxWidth
                    ) {
                        items(filteredEmployees, key = { it.user.uid }) { status ->
                            Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                                // SH-268: a group manager's engagement is the group's: the tap says so.
                                val viaGroup = status.user.engagements[state.currentWorkplaceId]?.isViaGroup == true
                                val open = state.currentWorkplaceId
                                    ?.takeIf { state.capabilities.shows(Gate.TEAM) }
                                    ?.let { workplaceId ->
                                        if (viaGroup) {
                                            { groupManagerShown = status.user }
                                        } else {
                                            { openEmployee(workplaceId, status.user.uid) }
                                        }
                                    }
                                // SH-98: right click: the person's actions (a tap opens the same form).
                                val nextShift = status.nextShift
                                val showNextShift = if (nextShift != null && onOpenShiftDay != null && state.capabilities.shows(Gate.ROSTERS)) {
                                    { onOpenShiftDay(nextShift.rosterId, nextShift.date) }
                                } else null
                                ContextMenuArea(items = { teamMemberMenu(memberMenuLabels, open, showNextShift) }) {
                                    // SH-269: in the selection mode a tap selects (Shift-click: a range).
                                    val key = com.evoapps.evoshift.viewmodels.MemberKey(state.currentWorkplaceId.orEmpty(), status.user.uid)
                                    SelectableMember(bulkState, key, teamKeys, onBulk, open) { onClick, picked ->
                                        TeamMemberCard(
                                            status = status,
                                            currentWorkplaceId = state.currentWorkplaceId,
                                            readiness = state.readinessByUserId[status.user.uid],
                                            leadRule = state.leadRule,
                                            onClick = onClick,
                                            selected = picked || (inPane && status.user.uid == paneEmployeeId)
                                        )
                                    }
                                }
                            }
                        }
                        // SH-267: people of the group's other workplaces with shifts here this month.
                        if (state.guests.isNotEmpty() && searchQuery.isBlank()) {
                            item(span = { GridItemSpan(maxLineSpan) }, key = "guests-header") { TeamGuestsHeader() }
                            items(state.guests, key = { "guest-${it.userId}" }) { guest -> TeamGuestCard(guest) }
                        }
                    }
                }
            }
                }
            )

            // SH-247: before the first list arrives the people's placeholders stand in (no spinner).
        }
    }

    groupManagerShown?.let { person ->
        val grant = person.engagements[state.currentWorkplaceId]?.groupGrant
        GroupManagerInfoDialog(
            name = person.displayName,
            groupName = grant?.groupName.orEmpty(),
            // Only the owner changes group managers.
            onOpenGroups = onOpenWorkplaceGroups?.takeIf { state.userPermission == UserPermission.OWNER },
            onDismiss = { groupManagerShown = null }
        )
    }

    // SH-269: "Edit selected": the sheet, then the summary before saving.
    if (bulkState?.editing == true) {
        val plan = bulkState.plan
        if (plan == null) {
            BulkEditDialog(bulkState, onBulk)
        } else {
            BulkSummaryDialog(plan, bulkState.isWorking, currency = { bulkState.currencies[it].orEmpty() }, onEvent = onBulk)
        }
    }
}

/** SH-268: a group's name as the Team shows it (the default group: "All workplaces"). */
@Composable
private fun groupLabel(groupName: String): String =
    groupName.ifBlank { stringResource(Res.string.workplace_groups_default_name) }

/**
 * SH-268: a group manager tapped in the Team: they manage this workplace through the group, so
 * their engagement is not edited or ended here; the owner changes it in the workplace groups.
 */
@Composable
private fun GroupManagerInfoDialog(name: String, groupName: String, onOpenGroups: (() -> Unit)?, onDismiss: () -> Unit) {
    com.evoapps.evoshift.widgets.EvoDialog(
        title = stringResource(Res.string.team_group_manager_title),
        onDismiss = onDismiss,
        icon = Icons.Default.Group,
        confirm = onOpenGroups?.let { open ->
            com.evoapps.evoshift.widgets.DialogAction(stringResource(Res.string.team_group_manager_open_groups), {
                onDismiss()
                open()
            })
        },
        dismiss = com.evoapps.evoshift.widgets.DialogAction(stringResource(Res.string.ok), onDismiss)
    ) {
        Text(stringResource(Res.string.team_group_manager_info, name, groupLabel(groupName)), style = MaterialTheme.typography.bodyMedium)
    }
}

/** SH-247: how many people's cards stand in for the team on its way. */
private const val TEAM_PLACEHOLDERS = 6

/** SH-267: "Guests this month" over the borrowed people's cards. */
@Composable
private fun TeamGuestsHeader() {
    Column(Modifier.fillMaxWidth().padding(top = 16.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
        Text(stringResource(Res.string.team_guests_title), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
        Text(stringResource(Res.string.team_guests_hint), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
    }
}

/**
 * SH-267: a borrowed person: their name and where they come from. Not the workplace's to open:
 * their pay terms, documents and requests stay with their own workplace.
 */
@Composable
private fun TeamGuestCard(guest: com.evoapps.evoshift.viewmodels.TeamGuest) {
    com.evoapps.evoshift.widgets.SurfaceCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Text(guest.displayName, style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold)
            guest.homeWorkplaceName?.let {
                Text(stringResource(Res.string.roster_picker_guest_from, it), style = MaterialTheme.typography.bodySmall)
            }
        }
    }
}


@Composable
fun TeamMemberCard(
    status: TeamMemberStatus,
    currentWorkplaceId: String?,
    /** Opens the person's form; null when the viewer does not manage the team. */
    onClick: (() -> Unit)?,
    /** SH-47: their medical exam / OHS statuses (managers only); expired or ending soon show as chips. */
    readiness: com.evoapps.evoshift.domain.model.StaffReadiness? = null,
    /** SH-104: who leads shifts here, for the star. */
    leadRule: com.evoapps.evoshift.domain.model.ShiftLeadRule = com.evoapps.evoshift.domain.model.ShiftLeadRule(),
    /** SH-105: the person shown in the detail pane beside the list (wide windows). */
    selected: Boolean = false
) {
    val user = status.user
    val engagement = user.engagements[currentWorkplaceId]
    // SH-268: a group manager reads as one, with the group's name.
    val grant = engagement?.groupGrant
    val role = if (grant != null) {
        stringResource(Res.string.team_group_manager, groupLabel(grant.groupName))
    } else engagement?.role ?: stringResource(Res.string.skeleton_no_role)
    val isActive = engagement?.isActive == true
    
    val isWorkingNow = status.isWorkingNow
    val nextShift = status.nextShift

    val statusColor = if (isWorkingNow) Color(0xFF2E7D32) else Color(0xFFFBC02D)

    val statusText = if (isWorkingNow) {
        val shift = status.currentShift
        val start = shift?.actualTime?.start?.takeIf { it.isNotEmpty() } ?: shift?.plannedTime?.start.orEmpty()
        stringResource(Res.string.team_at_work_since, start.substringAfter('T').take(5))
    } else if (nextShift != null) {
        val today = remember { AppClock.todayIn(TimeZone.currentSystemDefault()) }
        val date = LocalDate.parse(nextShift.date)
        val day = when (date) {
            today -> stringResource(Res.string.dashboard_today)
            today.plus(DatePeriod(days = 1)) -> stringResource(Res.string.dashboard_tomorrow)
            else -> "${date.day.toString().padStart(2, '0')}.${date.month.number.toString().padStart(2, '0')}"
        }
        stringResource(Res.string.team_next_shift, day, nextShift.plannedTime.start.substringAfter('T').take(5))
    } else {
        stringResource(Res.string.team_no_scheduled_shifts)
    }

    RegularCard(
        onClick = onClick,
        modifier = Modifier
            .fillMaxWidth()
            .then(if (selected) Modifier.border(2.dp, DarkGold, RoundedCornerShape(20.dp)) else Modifier)
            .hoverLift()
    ) {
        Row(
            modifier = Modifier
                .padding(16.dp)
                .fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.weight(1f)
            ) {
                // SH-94: the person's profile photo (uploaded or from Google) when they have one.
                if (!user.photoUrl.isNullOrBlank()) {
                    com.evoapps.evoshift.widgets.UserAvatar(name = user.displayName, photoUrl = user.photoUrl, size = 48.dp)
                } else Box(
                    modifier = Modifier
                        .size(48.dp)
                        .clip(CircleShape)
                        .background(DeepNavy),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = user.displayName.firstOrNull()?.toString()?.uppercase() ?: "?",
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = Color.White
                    )
                }

                Spacer(modifier = Modifier.width(16.dp))

                Column {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(
                            text = user.displayName,
                            style = MaterialTheme.typography.titleMedium.copy(
                                fontWeight = FontWeight.Bold
                            ),
                            color = DeepNavy,
                            modifier = Modifier.weight(1f, fill = false)
                        )
                        // SH-47: shift lead star, "needs supervision" mark.
                        StaffBadges(engagement, leadRule, user.uid, size = 16.dp, modifier = Modifier.padding(start = 6.dp))
                    }
                    Text(
                        text = role,
                        style = MaterialTheme.typography.bodyMedium,
                        color = DeepNavy.copy(alpha = 0.7f)
                    )
                    if (isActive) StaffCheckChips(readiness, Modifier.padding(top = 4.dp))
                }
            }

            if (isActive) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.End
                ) {
                    Column(horizontalAlignment = Alignment.End) {
                         Box(
                            modifier = Modifier
                                .size(8.dp)
                                .clip(CircleShape)
                                .background(if (nextShift == null && !isWorkingNow) Color.Gray else statusColor)
                                .align(Alignment.End)
                        )
                        Spacer(modifier = Modifier.height(4.dp))
                        Text(
                            text = statusText,
                            style = MaterialTheme.typography.labelSmall.copy(
                                textAlign = TextAlign.End
                            ),
                            color = DeepNavy.copy(alpha = 0.8f),
                            lineHeight = 14.sp
                        )
                    }
                }
            } else {
                 Text(
                     text = stringResource(Res.string.team_inactive),
                    style = MaterialTheme.typography.labelMedium,
                     color = Color(0xFFD32F2F)
                )
            }
        }
    }
}

/** SH-98: the texts of a person's right-click menu, resolved once for the list. */
internal class TeamMemberMenuLabels(val open: String, val showNextShift: String)

/**
 * SH-98: a person's right-click menu in the team list: their form (what a tap opens) and, for
 * those who build rosters, their next shift's day in the roster.
 */
internal fun teamMemberMenu(
    labels: TeamMemberMenuLabels,
    onOpen: (() -> Unit)?,
    onShowNextShift: (() -> Unit)?
): List<ContextMenuItem> = buildList {
    onOpen?.let { add(ContextMenuItem(labels.open, it, Icons.Default.Person)) }
    onShowNextShift?.let { add(ContextMenuItem(labels.showNextShift, it, Icons.Default.Event)) }
}
